import Store from "@/store/index";

import PersonalEmployee from "@/pages/personal-employee/index";
import PersonalEmployeeInventoryItems from "@/pages/personal-employee/inventory-items/index";
import PersonalEmployeeProfile from "@/pages/personal-employee/profile/index";
import PersonalEmployeeDiscipline from "@/pages/personal-employee/discipline";
import PersonalEmployeeReferrals from "@/pages/personal-employee/referrals";
import PersonalEmployeeDocuments from "@/pages/personal-employee/documents";
import PersonalEmployeeQuestionnaire from "@/pages/personal-employee/questionnaire";
import PersonalEmployeeAgreements from "@/pages/personal-employee/agreements";
import PersonalEmployeeSummary from "@/pages/personal-employee/summary";
import PersonalEmployeeMoveInCompany from "@/pages/personal-employee/move-in-company";
import PersonalEmployeeMainFactors from "@/pages/personal-employee/main-factors";
import PersonalEmployeeFinance from "@/pages/personal-employee/finance/index";

import { userPermissionsList } from "@/constants/userPermissions";

export default [
    {
        path: "/personal-employee/:id",
        component: PersonalEmployee,
        children: [
            {
                path: "summary",
                name: "personal-employee-summary",
                component: PersonalEmployeeSummary,
                meta: {
                    title: "Личное дело — сводка",
                },
                props: true,
                beforeEnter: (to, from, next) => {
                    const summaryPermissions = ["viewOwnSummary", "viewWorkerSummary"];
                    const userPermissions = Store.state.userPermissions;
                    const isAvailablePage = userPermissions.some((permission) =>
                        summaryPermissions.includes(permission),
                    );
                    if (isAvailablePage) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                },
            },
            {
                path: "move-in-company",
                name: "personal-employee-move-in-company",
                component: PersonalEmployeeMoveInCompany,
                meta: {
                    title: "Личное дело — движение в компании",
                },
                beforeEnter: (to, from, next) => {
                    const userPermissions = Store.state.userPermissions;
                    const c = userPermissions.findIndex((permission) => permission === "viewWorkerHistory");
                    if (c !== -1) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                },
            },
            {
                path: "agreements",
                name: "personal-employee-agreements",
                component: PersonalEmployeeAgreements,
                meta: {
                    title: "Личное дело — договоры",
                },
                beforeEnter: (to, from, next) => {
                    const userPermissions = Store.state.userPermissions;
                    const c = userPermissions.findIndex((permission) => permission === "viewWorkerAgreements");
                    if (c !== -1) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                },
            },
            {
                path: "questionnaire",
                name: "personal-employee-questionnaire",
                component: PersonalEmployeeQuestionnaire,
                meta: {
                    title: "Личное дело — анкета",
                },
            },
            {
                path: "main-factors",
                name: "personal-employee-main-factors",
                component: PersonalEmployeeMainFactors,
                meta: {
                    title: "Личное дело — основные показатели",
                },
                beforeEnter: (to, from, next) => {
                    const userPermissions = Store.state.userPermissions;
                    const c = userPermissions.findIndex((permission) => permission === "viewMainFactors");
                    if (c !== -1) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                },
            },
            {
                path: "finance",
                name: "personal-employee-finance",
                meta: {
                    title: "Личное дело — финансы",
                },
                component: PersonalEmployeeFinance,
                beforeEnter: (to, from, next) => {
                    const financePermissions = [
                        "updatePersonalAmount",
                        "viewOwnPersonalAmount",
                        "viewPersonalAmount",
                        "updateWorkerDeposit",
                        "viewOwnDeposit",
                        "viewWorkerDeposit",
                        "updateAccountableHistory",
                        "viewAccountableHistory",
                    ];
                    const userPermissions = Store.state.userPermissions;
                    const isAvailablePage = userPermissions.some((permission) =>
                        financePermissions.includes(permission),
                    );
                    if (isAvailablePage) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                },
            },

            {
                path: "inventory-items",
                name: "personal-employee-inventory-items",
                component: PersonalEmployeeInventoryItems,
                meta: {
                    title: "Личное дело — ТМЦ",
                },
                beforeEnter: (to, from, next) => {
                    const inventoryItemsPermissions = ["updateWorkerUniform", "viewOwnUniform", "viewWorkerUniform"];
                    const userPermissions = Store.state.userPermissions;
                    const isAvailablePage = userPermissions.some((permission) =>
                        inventoryItemsPermissions.includes(permission),
                    );
                    if (isAvailablePage) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                },
            },
            {
                path: "profile",
                name: "personal-employee-profile",
                component: PersonalEmployeeProfile,
                meta: {
                    title: "Личное дело — анкета",
                },
                beforeEnter: (to, from, next) => {
                    const permissions = [
                        userPermissionsList.worker.profile.view,
                        userPermissionsList.worker.profile.edit,
                    ];
                    const userPermissions = Store.state.userPermissions;
                    const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                    if (isAvailablePage) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                },
            },
            {
                path: "discipline",
                name: "personal-employee-discipline",
                component: PersonalEmployeeDiscipline,
                meta: {
                    title: "Личное дело — дисциплина",
                },
                beforeEnter: (to, from, next) => {
                    const disciplinePermissions = ["viewFineBonus", "viewOwnFineBonus"];
                    const userPermissions = Store.state.userPermissions;
                    const isAvailablePage = userPermissions.some((permission) =>
                        disciplinePermissions.includes(permission),
                    );
                    if (isAvailablePage) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                },
            },
            {
                path: "referrals",
                name: "personal-employee-referrals",
                component: PersonalEmployeeReferrals,
                meta: {
                    title: "Личное дело — приведенные сотрудники",
                },
                beforeEnter: (to, from, next) => {
                    const referralsPermissions = [
                        "updateAllInvitedWorkers",
                        "viewAllInvitedWorkers",
                        "viewInvitedWorkers",
                        "workerBonusControl",
                    ];
                    const userPermissions = Store.state.userPermissions;
                    const isAvailablePage = userPermissions.some((permission) =>
                        referralsPermissions.includes(permission),
                    );
                    if (isAvailablePage) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                },
            },
            {
                path: "documents",
                name: "personal-employee-documents",
                component: PersonalEmployeeDocuments,
                meta: {
                    title: "Личное дело — документы",
                },
                props: true,
                beforeEnter: (to, from, next) => {
                    const documentsPermissions = [
                        userPermissionsList.worker.documents.view,
                        userPermissionsList.worker.documents.control,
                        userPermissionsList.worker.documents.own,
                    ];
                    const medicalPermissions = [
                        userPermissionsList.worker.medicalAnalyses.view,
                        userPermissionsList.worker.medicalAnalyses.control,
                    ];
                    const allPermissions = [...documentsPermissions, ...medicalPermissions];
                    const userPermissions = Store.state.userPermissions;
                    const isAvailablePage = userPermissions.some((permission) => allPermissions.includes(permission));
                    const isMedicalDocumentsAvailable = userPermissions.some((permission) =>
                        medicalPermissions.includes(permission),
                    );
                    const { query } = to;

                    if (!isAvailablePage) {
                        next({ name: "error-403" });
                        return;
                    }
                    if (query.tab && query.tab === "medical_documents" && !isMedicalDocumentsAvailable) {
                        next({ name: "error-403" });
                        return;
                    }
                    next();
                },
            },
        ],
        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                Store.dispatch("getUserPermissions").then(() => {
                    next();
                });
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },
];
